import {Checkboxes} from 'mui-rff';
import React from "react";


export default function CheckboxesAdapter(props) {

  return (<Checkboxes
    {...props}
  />)

}